import { render, staticRenderFns } from "./courseRecent.vue?vue&type=template&id=e5cba4b0"
import script from "./courseRecent.vue?vue&type=script&lang=js"
export * from "./courseRecent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports